/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRuleRequest extends models.RecommendationExclusionRuleBase {
    getFixupPrototypeFunction() { return RecommendationExclusionRuleRequest.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRuleRequest>): RecommendationExclusionRuleRequest {
        let obj = Object.assign(new RecommendationExclusionRuleRequest(), model);
        RecommendationExclusionRuleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRuleRequest>): RecommendationExclusionRuleRequest {
        if (!model) return null;
        return RecommendationExclusionRuleRequest.newInstance(<RecommendationExclusionRuleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRuleRequest) {
        if (!obj) return;

        models.RecommendationExclusionRuleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRuleRequest): boolean {
        if (models.RecommendationExclusionRuleBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationExclusionRuleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.policy_classification) {
            models.PolicyClassificationWithSubClassifications.fixupPrototype(this.policy_classification);
        }
    }

    /**
     * Policy classification with sub-classifications.
     */
    policy_classification: models.PolicyClassificationWithSubClassifications;

}
